/* eslint-disable */

/** unique or primary key constraints on table "fis.asset_code" */
export enum FisAssetCodeConstraint {
  /** unique or primary key constraint on columns "asset_code_id" */
  AssetCodePkey = 'asset_code_pkey',
  /** unique or primary key constraint on columns "context_id", "data_label_id", "asset_type_id", "code" */
  AssetCodeUniqueCode = 'asset_code_unique_code'
}

/** select columns of table "fis.asset_code" */
export enum FisAssetCodeSelectColumn {
  /** column name */
  AssetTypeId = 'asset_type_id',
  /** column name */
  Code = 'code',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CoreState = 'core_state',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "fis.asset_code" */
export enum FisAssetCodeUpdateColumn {
  /** column name */
  AssetTypeId = 'asset_type_id',
  /** column name */
  Code = 'code',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CoreState = 'core_state',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** unique or primary key constraints on table "fis.asset" */
export enum FisAssetConstraint {
  /** unique or primary key constraint on columns "asset_id", "asset_type_id" */
  AssetAssetIdAssetTypeIdFkey = 'asset_asset_id_asset_type_id_fkey',
  /** unique or primary key constraint on columns "context_id", "name_unique", "location_id" */
  AssetNameKey = 'asset_name_key',
  /** unique or primary key constraint on columns "asset_id" */
  AssetPkey = 'asset_pkey'
}

/** select columns of table "fis.asset" */
export enum FisAssetSelectColumn {
  /** column name */
  AssetTypeId = 'asset_type_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CycleTime = 'cycle_time',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "fis_asset_aggregate_bool_exp_bool_and_arguments_columns" columns of table "fis.asset" */
export enum FisAssetSelectColumnFisAssetAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "fis_asset_aggregate_bool_exp_bool_or_arguments_columns" columns of table "fis.asset" */
export enum FisAssetSelectColumnFisAssetAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** unique or primary key constraints on table "fis.asset_tag" */
export enum FisAssetTagConstraint {
  /** unique or primary key constraint on columns "asset_tag_id" */
  AssetTagPkey = 'asset_tag_pkey',
  /** unique or primary key constraint on columns "context_id", "name" */
  AssetTagUniqueName = 'asset_tag_unique_name'
}

/** unique or primary key constraints on table "fis.asset_tag_link" */
export enum FisAssetTagLinkConstraint {
  /** unique or primary key constraint on columns "asset_tag_link_id" */
  AssetTagLinkPkey = 'asset_tag_link_pkey',
  /** unique or primary key constraint on columns "asset_id", "asset_tag_id" */
  AssetTagLinkUnique = 'asset_tag_link_unique'
}

/** select columns of table "fis.asset_tag_link" */
export enum FisAssetTagLinkSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  AssetTagId = 'asset_tag_id',
  /** column name */
  Id = 'id'
}

/** update columns of table "fis.asset_tag_link" */
export enum FisAssetTagLinkUpdateColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  AssetTagId = 'asset_tag_id',
  /** column name */
  Id = 'id'
}

/** select columns of table "fis.asset_tag" */
export enum FisAssetTagSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name'
}

/** update columns of table "fis.asset_tag" */
export enum FisAssetTagUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name'
}

/** unique or primary key constraints on table "fis.asset_type" */
export enum FisAssetTypeConstraint {
  /** unique or primary key constraint on columns "asset_type_id" */
  AssetTypePkey = 'asset_type_pkey',
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  AssetTypeUniqueName = 'asset_type_unique_name'
}

/** select columns of table "fis.asset_type" */
export enum FisAssetTypeSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "fis.asset_type" */
export enum FisAssetTypeUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "fis.asset" */
export enum FisAssetUpdateColumn {
  /** column name */
  AssetTypeId = 'asset_type_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  CycleTime = 'cycle_time',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** unique or primary key constraints on table "fis.core_state" */
export enum FisCoreStateConstraint {
  /** unique or primary key constraint on columns "state" */
  CoreStatePkey = 'core_state_pkey'
}

export enum FisCoreStateEnum {
  /** Blocked */
  Blocked = 'blocked',
  /** Blocked Secondary */
  BlockedSecondary = 'blocked_secondary',
  /** Bypassed */
  Bypassed = 'bypassed',
  /** Cycling */
  Cycling = 'cycling',
  /** Down External */
  DownExternal = 'down_external',
  /** Fault */
  Fault = 'fault',
  /** Manual Intervention */
  ManualIntervention = 'manual_intervention',
  /** No Comm */
  NoComm = 'no_comm',
  /** None */
  None = 'none',
  /** Starved */
  Starved = 'starved',
  /** Starved Secondary */
  StarvedSecondary = 'starved_secondary'
}

/** select columns of table "fis.core_state" */
export enum FisCoreStateSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  State = 'state'
}

/** update columns of table "fis.core_state" */
export enum FisCoreStateUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  State = 'state'
}

/** unique or primary key constraints on table "fis.data" */
export enum FisDataConstraint {
  /** unique or primary key constraint on columns "time", "data_id" */
  DataPkey = 'data_pkey'
}

/** unique or primary key constraints on table "fis.data_label" */
export enum FisDataLabelConstraint {
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  DataLabelEnforceUnique = 'data_label_enforce_unique',
  /** unique or primary key constraint on columns "data_label_id" */
  DataLabelPkey = 'data_label_pkey'
}

/** select columns of table "fis.data_label" */
export enum FisDataLabelSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "fis_data_label_aggregate_bool_exp_bool_and_arguments_columns" columns of table "fis.data_label" */
export enum FisDataLabelSelectColumnFisDataLabelAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "fis_data_label_aggregate_bool_exp_bool_or_arguments_columns" columns of table "fis.data_label" */
export enum FisDataLabelSelectColumnFisDataLabelAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** update columns of table "fis.data_label" */
export enum FisDataLabelUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select columns of table "fis.data" */
export enum FisDataSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataId = 'data_id',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  Time = 'time',
  /** column name */
  Timing = 'timing'
}

/** select "fis_data_aggregate_bool_exp_avg_arguments_columns" columns of table "fis.data" */
export enum FisDataSelectColumnFisDataAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  NumVal = 'num_val'
}

/** select "fis_data_aggregate_bool_exp_corr_arguments_columns" columns of table "fis.data" */
export enum FisDataSelectColumnFisDataAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  NumVal = 'num_val'
}

/** select "fis_data_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "fis.data" */
export enum FisDataSelectColumnFisDataAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  NumVal = 'num_val'
}

/** select "fis_data_aggregate_bool_exp_max_arguments_columns" columns of table "fis.data" */
export enum FisDataSelectColumnFisDataAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  NumVal = 'num_val'
}

/** select "fis_data_aggregate_bool_exp_min_arguments_columns" columns of table "fis.data" */
export enum FisDataSelectColumnFisDataAggregateBoolExpMinArgumentsColumns {
  /** column name */
  NumVal = 'num_val'
}

/** select "fis_data_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "fis.data" */
export enum FisDataSelectColumnFisDataAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  NumVal = 'num_val'
}

/** select "fis_data_aggregate_bool_exp_sum_arguments_columns" columns of table "fis.data" */
export enum FisDataSelectColumnFisDataAggregateBoolExpSumArgumentsColumns {
  /** column name */
  NumVal = 'num_val'
}

/** select "fis_data_aggregate_bool_exp_var_samp_arguments_columns" columns of table "fis.data" */
export enum FisDataSelectColumnFisDataAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  NumVal = 'num_val'
}

/** unique or primary key constraints on table "fis.data_timing" */
export enum FisDataTimingConstraint {
  /** unique or primary key constraint on columns "timing" */
  DataTimingPkey = 'data_timing_pkey'
}

export enum FisDataTimingEnum {
  /** When the data represents what occured over a period of time */
  End = 'end',
  /** When the data represents the start of the event */
  Start = 'start'
}

/** select columns of table "fis.data_timing" */
export enum FisDataTimingSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Timing = 'timing'
}

/** update columns of table "fis.data_timing" */
export enum FisDataTimingUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Timing = 'timing'
}

/** unique or primary key constraints on table "fis.data_track_count" */
export enum FisDataTrackCountConstraint {
  /** unique or primary key constraint on columns "calendar_event_id", "data_label_id", "time", "asset_id", "shift_calendar_event_id" */
  DataTrackCountPkey = 'data_track_count_pkey'
}

/** select columns of table "fis.data_track_count" */
export enum FisDataTrackCountSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  Count = 'count',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  EventDuration = 'event_duration',
  /** column name */
  IsProductive = 'is_productive',
  /** column name */
  Meta = 'meta',
  /** column name */
  ShiftCalendarEventId = 'shift_calendar_event_id',
  /** column name */
  Time = 'time',
  /** column name */
  TimeRange = 'time_range'
}

/** update columns of table "fis.data_track_count" */
export enum FisDataTrackCountUpdateColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  Count = 'count',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  EventDuration = 'event_duration',
  /** column name */
  IsProductive = 'is_productive',
  /** column name */
  Meta = 'meta',
  /** column name */
  ShiftCalendarEventId = 'shift_calendar_event_id',
  /** column name */
  Time = 'time',
  /** column name */
  TimeRange = 'time_range'
}

/** unique or primary key constraints on table "fis.data_track_duration" */
export enum FisDataTrackDurationConstraint {
  /** unique or primary key constraint on columns "calendar_event_id", "data_label_id", "time", "asset_id", "shift_calendar_event_id", "num_val" */
  DataTrackDurationPkey = 'data_track_duration_pkey'
}

/** select columns of table "fis.data_track_duration" */
export enum FisDataTrackDurationSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  EventDuration = 'event_duration',
  /** column name */
  IsProductive = 'is_productive',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  Occurrence = 'occurrence',
  /** column name */
  ShiftCalendarEventId = 'shift_calendar_event_id',
  /** column name */
  Time = 'time',
  /** column name */
  TimeRange = 'time_range'
}

/** update columns of table "fis.data_track_duration" */
export enum FisDataTrackDurationUpdateColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  EventDuration = 'event_duration',
  /** column name */
  IsProductive = 'is_productive',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  Occurrence = 'occurrence',
  /** column name */
  ShiftCalendarEventId = 'shift_calendar_event_id',
  /** column name */
  Time = 'time',
  /** column name */
  TimeRange = 'time_range'
}

/** unique or primary key constraints on table "fis.data_track_scalar" */
export enum FisDataTrackScalarConstraint {
  /** unique or primary key constraint on columns "data_label_id", "time", "asset_id" */
  DataTrackScalarPkey = 'data_track_scalar_pkey'
}

/** select columns of table "fis.data_track_scalar" */
export enum FisDataTrackScalarSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  AvgVal = 'avg_val',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  MaxVal = 'max_val',
  /** column name */
  Meta = 'meta',
  /** column name */
  MinVal = 'min_val',
  /** column name */
  Occurrence = 'occurrence',
  /** column name */
  SumVal = 'sum_val',
  /** column name */
  Time = 'time',
  /** column name */
  TimeRange = 'time_range'
}

/** update columns of table "fis.data_track_scalar" */
export enum FisDataTrackScalarUpdateColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  AvgVal = 'avg_val',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  MaxVal = 'max_val',
  /** column name */
  Meta = 'meta',
  /** column name */
  MinVal = 'min_val',
  /** column name */
  Occurrence = 'occurrence',
  /** column name */
  SumVal = 'sum_val',
  /** column name */
  Time = 'time',
  /** column name */
  TimeRange = 'time_range'
}

/** unique or primary key constraints on table "fis.data_type" */
export enum FisDataTypeConstraint {
  /** unique or primary key constraint on columns "type" */
  DataTypePkey = 'data_type_pkey'
}

export enum FisDataTypeEnum {
  /** Code */
  Code = 'code',
  /** Counter */
  Counter = 'counter',
  /** Scalar */
  Scalar = 'scalar',
  /** State */
  State = 'state',
  /** Timer */
  Timer = 'timer'
}

/** select columns of table "fis.data_type" */
export enum FisDataTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** update columns of table "fis.data_type" */
export enum FisDataTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** update columns of table "fis.data" */
export enum FisDataUpdateColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataId = 'data_id',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  Time = 'time',
  /** column name */
  Timing = 'timing'
}

/** select columns of table "fis.report_constraint" */
export enum FisReportConstraintSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  BadCount = 'bad_count',
  /** column name */
  Blocked = 'blocked',
  /** column name */
  BlockedSecondary = 'blocked_secondary',
  /** column name */
  Bypassed = 'bypassed',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  CycleTime = 'cycle_time',
  /** column name */
  Cycling = 'cycling',
  /** column name */
  DownExternal = 'down_external',
  /** column name */
  Duration = 'duration',
  /** column name */
  Fault = 'fault',
  /** column name */
  GoodCount = 'good_count',
  /** column name */
  IsProductive = 'is_productive',
  /** column name */
  ManualIntervention = 'manual_intervention',
  /** column name */
  NoComm = 'no_comm',
  /** column name */
  ProductiveDuration = 'productive_duration',
  /** column name */
  ShiftCalendarEventId = 'shift_calendar_event_id',
  /** column name */
  Starved = 'starved',
  /** column name */
  StarvedSecondary = 'starved_secondary',
  /** column name */
  Time = 'time'
}

/** select columns of table "fis.report_detail" */
export enum FisReportDetailSelectColumn {
  /** column name */
  AssetCodeId = 'asset_code_id',
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataId = 'data_id',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  Time = 'time',
  /** column name */
  Timing = 'timing'
}

/** select columns of table "fis.report_mtbf" */
export enum FisReportMtbfSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  ExtDuration = 'ext_duration',
  /** column name */
  ExtOccurrence = 'ext_occurrence',
  /** column name */
  MfDuration = 'mf_duration',
  /** column name */
  MfOccurrence = 'mf_occurrence',
  /** column name */
  MiDuration = 'mi_duration',
  /** column name */
  MiOccurrence = 'mi_occurrence',
  /** column name */
  ProductiveTime = 'productive_time'
}

/** select columns of table "fis.report_oee" */
export enum FisReportOeeSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  BadCount = 'bad_count',
  /** column name */
  Blocked = 'blocked',
  /** column name */
  BlockedSecondary = 'blocked_secondary',
  /** column name */
  Bypassed = 'bypassed',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  CycleTime = 'cycle_time',
  /** column name */
  Cycling = 'cycling',
  /** column name */
  DownExternal = 'down_external',
  /** column name */
  Duration = 'duration',
  /** column name */
  Fault = 'fault',
  /** column name */
  GoodCount = 'good_count',
  /** column name */
  IsProductive = 'is_productive',
  /** column name */
  ManualIntervention = 'manual_intervention',
  /** column name */
  NoComm = 'no_comm',
  /** column name */
  ProductiveDuration = 'productive_duration',
  /** column name */
  ShiftCalendarEventId = 'shift_calendar_event_id',
  /** column name */
  Starved = 'starved',
  /** column name */
  StarvedSecondary = 'starved_secondary',
  /** column name */
  Time = 'time'
}

/** select columns of table "fis.report_state_column" */
export enum FisReportStateColumnSelectColumn {
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  DataLabelName = 'data_label_name',
  /** column name */
  Description = 'description',
  /** column name */
  NumVal = 'num_val'
}

/** select columns of table "fis.report_state" */
export enum FisReportStateSelectColumn {
  /** column name */
  AssetCodeId = 'asset_code_id',
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  IsProductive = 'is_productive',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  Occurrence = 'occurrence',
  /** column name */
  ShiftCalendarEventId = 'shift_calendar_event_id',
  /** column name */
  Time = 'time',
  /** column name */
  TimeRange = 'time_range'
}

/** select columns of table "fis.report_top_fault" */
export enum FisReportTopFaultSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  DataLabelId = 'data_label_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  EventDuration = 'event_duration',
  /** column name */
  IsProductive = 'is_productive',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  Occurrence = 'occurrence',
  /** column name */
  ShiftCalendarEventId = 'shift_calendar_event_id',
  /** column name */
  Time = 'time',
  /** column name */
  TimeRange = 'time_range'
}

